import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Zap, PlayCircle } from "lucide-react";

export default function Simulator() {
  const [form, setForm] = useState({
    customer_name: "Maria Silva",
    customer_phone: "+5511999998888",
    amount: 97.0,
    external_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [lastTx, setLastTx] = useState(null);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const fire = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/simulate/pix-generated", {
        ...form,
        amount: Number(form.amount),
        external_id: form.external_id || undefined,
      });
      setLastTx(data);
      toast.success("PIX de teste gerado! Motor de recuperação iniciou.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Falha ao simular");
    }
    setLoading(false);
  };

  return (
    <div className="space-y-8" data-testid="simulator-page">
      <div>
        <div className="font-mono text-xs uppercase tracking-widest text-cp-primary-light mb-2">_simulador</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tighter">Gerar PIX de teste</h1>
        <p className="text-slate-400 text-sm mt-2">
          Dispare um evento de PIX gerado sem precisar do checkout real. No modo <strong className="text-amber-300">Demo</strong>, a primeira
          mensagem sai em 10 segundos.
        </p>
      </div>

      <div className="border border-white/[0.06] bg-cp-bg p-6 md:p-8 max-w-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-sm bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
            <Zap className="h-5 w-5 text-amber-400" />
          </div>
          <div>
            <div className="font-heading text-lg font-semibold">Novo PIX simulado</div>
            <div className="text-xs text-slate-500 font-mono uppercase tracking-widest mt-0.5">dispara motor de recuperação</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-slate-500 mb-2">Nome cliente</label>
            <input
              value={form.customer_name}
              onChange={update("customer_name")}
              data-testid="sim-name-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary focus:ring-2 focus:ring-cp-primary/30 outline-none text-sm px-4 py-3 rounded-sm"
            />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-slate-500 mb-2">Telefone (com DDI)</label>
            <input
              value={form.customer_phone}
              onChange={update("customer_phone")}
              data-testid="sim-phone-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary focus:ring-2 focus:ring-cp-primary/30 outline-none text-sm px-4 py-3 rounded-sm font-mono"
              placeholder="+5511999999999"
            />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-slate-500 mb-2">Valor (R$)</label>
            <input
              type="number"
              step="0.01"
              value={form.amount}
              onChange={update("amount")}
              data-testid="sim-amount-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary focus:ring-2 focus:ring-cp-primary/30 outline-none text-sm px-4 py-3 rounded-sm font-mono tabular-nums"
            />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-widest text-slate-500 mb-2">External ID (opcional)</label>
            <input
              value={form.external_id}
              onChange={update("external_id")}
              data-testid="sim-externalid-input"
              className="w-full bg-cp-elevated border border-white/10 focus:border-cp-primary focus:ring-2 focus:ring-cp-primary/30 outline-none text-sm px-4 py-3 rounded-sm font-mono"
              placeholder="ORDER_ABC123"
            />
          </div>
        </div>

        <button
          onClick={fire}
          disabled={loading}
          data-testid="fire-sim-btn"
          className="mt-6 bg-cp-primary hover:bg-cp-primary-hover disabled:opacity-50 text-cp-bg font-bold px-6 py-3 rounded-sm transition-all inline-flex items-center gap-2"
        >
          <PlayCircle className="h-5 w-5" /> {loading ? "Disparando..." : "Disparar PIX de teste"}
        </button>

        {lastTx && (
          <div className="mt-6 p-4 border border-cp-primary/30 bg-cp-primary/5 rounded-sm" data-testid="sim-result">
            <div className="font-mono text-xs text-cp-primary-light mb-2">✓ Transação criada</div>
            <pre className="text-xs text-slate-300 overflow-x-auto font-mono">{JSON.stringify(lastTx, null, 2)}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
